import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { money, formatDate } from "@/lib/format";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/admin/customers", { params: { search: search || undefined } }).then((res) => setCustomers(res.data));
  useEffect(() => { load(); }, [search]);

  const open = (id) => api.get(`/admin/customers/${id}`).then((res) => setSelected(res.data));

  return (
    <div className="p-8" data-testid="admin-customers-page">
      <h1 className="font-serif text-3xl mb-6 text-zinc-900">Customers</h1>
      <input placeholder="Search name or email" value={search} onChange={(e) => setSearch(e.target.value)} className="border border-zinc-200 rounded-full px-4 py-2 text-sm mb-6 w-full max-w-sm focus:border-teal-600 outline-none" data-testid="admin-customer-search" />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white border border-zinc-200 rounded-xl overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-customers-table">
            <thead className="bg-zinc-50 text-xs font-heading uppercase text-zinc-500 text-left">
              <tr><th className="p-3">Name</th><th className="p-3">Orders</th><th className="p-3">Spend</th><th className="p-3">Credit</th></tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} onClick={() => open(c.id)} className="border-t border-zinc-100 cursor-pointer hover:bg-teal-50/40 text-zinc-800" data-testid={`customer-row-${c.id}`}>
                  <td className="p-3">{c.name}<div className="text-xs text-zinc-400">{c.email}</div></td>
                  <td className="p-3">{c.total_orders}</td>
                  <td className="p-3">{money(c.lifetime_spend)}</td>
                  <td className="p-3">{money(c.store_credit_balance)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {selected && (
          <div className="bg-white border border-zinc-200 rounded-xl p-5" data-testid="admin-customer-detail">
            <h2 className="font-heading text-sm uppercase tracking-wide mb-1 text-zinc-900">{selected.user.name}</h2>
            <p className="text-xs text-zinc-400 mb-4">{selected.user.email}</p>
            <h3 className="text-xs font-heading uppercase tracking-wide mb-2 text-zinc-500">Timeline</h3>
            <div className="space-y-2">
              {selected.timeline.map((t, i) => (
                <div key={i} className="text-xs border-b border-zinc-100 pb-2 text-zinc-700">
                  <span className="text-zinc-400">{formatDate(t.date)}</span> — {t.event}
                </div>
              ))}
              {selected.timeline.length === 0 && <p className="text-xs text-zinc-400">No activity yet.</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
